import isApiError from "@insite/client-framework/Common/isApiError";
import { createHandlerChainRunner, HasOnError, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { getReport, ReportParameter } from "@tKgpco/Services/CustomBackOrderedItemsService";
import { CustomApiHandler } from "@tKgpco/Store/CustomHandlerCreator";

type ReportParameterParam = HasOnSuccess & ReportParameter & HasOnError;

type HandlerType = CustomApiHandler<ReportParameterParam, BlobPart>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = (await getReport(props.apiParameter)) as unknown as BlobPart;
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            props.parameter.onError?.(error.errorJson.message);
            return false;
        }
        throw error;
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    console.log("props = ", props.parameter.reportFormat);
    if (props.apiResult) {
        // const blob = new Blob([props.apiResult]);
        // const url = window.URL.createObjectURL(blob);
        // const link = document.createElement("a");
        // link.href = url;
        // if (props.parameter.reportFormat === "excel") {
        //     link.setAttribute("download", `${"myExcel"}}.xlsx`);
        //     link.download = `${"myExcel"}${Date.now()}.xlsx`;
        //     link.click();
        // }else  if (props.parameter.reportFormat === "pdf") {
        //     link.setAttribute("download", `${"myPDF"}}.pdf`);
        //     link.download = `${"myPDF"}${Date.now()}.pdf`;
        //     link.click();
        // } else {
        //     // link.target = "_blank";
        //     link.click();
        //     // window.URL.revokeObjectURL(`${url}#toolbar=0`);
        // }

        if (props.parameter?.onSuccess) {
            props.parameter.onSuccess();
        }
    }
};

export const chain = [PopulateApiParameter, RequestDataFromApi, ExecuteOnSuccessCallback];

const backOrderedItemsReportHandler = createHandlerChainRunner(chain, "getReport");
export default backOrderedItemsReportHandler;
